import { createSelector } from 'reselect';

// (number) => String
export const currencyToString = createSelector(
  cents => cents * 0.01,
  currency => `$${currency.toFixed(2)}`
);
